import {
    DEFAULT_BUILDER,
    DEFAULT_PERMISSIONS,
    SCHEMA,
    BUILDERS,
    VISIBLE_TOAST_TYPES
} from './utils';
import BuilderFactory from './factory';
import transitions from './transitions';
import { fetchConcatenateInfo } from '../../api/audiostorage';
import { fetchBook } from '@speechki-frontend/core/book/api/books';
import merge from 'lodash/merge';

const INITITAL_DATA = {
    preparing: false,
    loading: false,
    error: undefined,
    selectedBuilder: null,
    builderFactory: undefined,
    preloadStatus: undefined,
    bookBuilds: [],
    dialogBrokenParts: false
};

export default {
    mixins: [transitions],
    data() {
        return {
            ...INITITAL_DATA,
            book: {},
            schema: undefined
        };
    },
    inject: ['registerWsHandler', 'removeWsHandler'],
    props: {
        bookId: {
            type: [Number, String],
            required: true
        },
        store: {
            type: Object,
            default: () => ({})
        },
        builders: {
            type: Array,
            default: () => []
        },
        combineBuilders: {
            type: Boolean,
            default: false
        },
        permissions: {
            type: Object,
            default: () => ({ ...DEFAULT_PERMISSIONS })
        },
        checkingParts: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isActualBuilds() {
            const { is_modified_build: isModified = false } = this.book;
            return !isModified;
        },
        isValid() {
            const { isValid = false } = this.builderFactory || {};
            return isValid;
        },
        canTrigger() {
            return ['build', 'builds', 'note_build', 'note_builds'].some(
                k => !!this.permissions[k]
            );
        },
        canSelectBuilder() {
            return this.getBuilders().some(builder => builder.getPermission('building'));
        },
        canBuilding() {
            return !this.loading && this.isValid;
        },
        isQueued() {
            return this.currentState !== 'queued';
        },
        computedBuilders() {
            if (!this.combineBuilders && this.builders.length) return this.builders;
            return merge(BUILDERS, this.builders);
        },
        buildersList() {
            if (!this.opened) return [];
            return this.getBuilders()
                .filter(builder => builder.getPermission('building'))
                .map(({ name }) => ({ name }));
        },
        apiContext() {
            const { book, bookId, schema, permissions } = this;
            const { params, query } = this.$route;
            return {
                book,
                bookId,
                schema,
                permissions,
                route: { params, query },
                ws: {
                    /*
                    @TODO: ...SocketService...
                    on: (e, cb, ctx) => this.registerWsHandler(e, cb, ctx),
                    off: (e, cb, ctx) => this.removeWsHandler(e, cb, ctx)
                    */
                    on: (e, cb, ctx) => this.registerWsHandler(e, cb.bind(ctx)),
                    off: (e, cb, ctx) => this.removeWsHandler(e, cb.bind(ctx))
                }
            };
        }
    },
    watch: {
        selectedBuilder(value) {
            if (this.builderFactory) {
                this.builderFactory.destroy();
                this.builderFactory = undefined;
            }
            if (!value) return false;
            this.initFactory(value);
        }
    },
    methods: {
        initFactory(name) {
            const builder = merge(
                { ...DEFAULT_BUILDER },
                BUILDERS.find(b => b.name === name),
                this.computedBuilders.find(b => b.name === name)
            );

            this.builderFactory = new BuilderFactory(builder, this.apiContext);
            this.builderFactory.subscribeEvents(this);
        },
        async fetchSchema() {
            const info = await fetchConcatenateInfo();
            const schema = Object.entries(SCHEMA).map(([field, options]) => {
                let { choises = [], filter = () => true } = options;
                let { [field]: extraChoises = [] } = info;
                choises = [...choises, ...extraChoises].filter(filter);

                return [field, { ...options, choises }];
            });

            this.schema = Object.fromEntries(new Map(schema));
        },
        fetchBook() {
            const store = { ...(this.$store.state.book || {}), ...this.store };
            let { book } = store;

            if (!book) {
                return this.refetchBook();
            }

            this.book = { ...book };
        },
        async refetchBook() {
            try {
                const book = await fetchBook(this.bookId);
                this.book = { ...book };
            } catch (error) {
                console.log(error);
            }
        },
        getBuilders() {
            return this.computedBuilders.slice().map(b => new BuilderFactory(b, this.apiContext));
        },
        async submit(event) {
            this.transition({ type: 'BUILDING' }, event);
        },
        reset() {
            Object.assign(this.$data, { ...INITITAL_DATA });
        },
        log(options = {}) {
            const { title, text, type = 'quiet' } = options;
            const name = `[${type}]: ${title || text || null}`;

            console.trace(name, options);
            if (VISIBLE_TOAST_TYPES.includes(type)) {
                this.$store.dispatch('pushToast', options);
            }
        }
    }
};
